// extracted by mini-css-extract-plugin
export default {"noTabs":"NoTabsMessage_noTabs__2YzoB","noTabsItem":"NoTabsMessage_noTabsItem__4TSC8"};